var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "home yoyo-container mx-auto min-h-screen",
      staticStyle: { "min-height": "100vh" },
    },
    [
      _c("navBar", { attrs: { title: _vm.$t("mine.favorites") } }),
      _c(
        "div",
        { staticClass: "px-4 mt-4" },
        [
          _c("property-grid", {
            attrs: { items: _vm.properties, showLiked: true },
            on: { updateFavorite: _vm.handleUpdateFavorite },
          }),
          !_vm.properties.length
            ? _c("van-empty", {
                attrs: { description: _vm.$t("common.noData") },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }